import axiosInstance from "app/axiosInstance";
import { ObjectsLocationsRequestDto } from "../entities/dtos/objects-locations-request.dto";
import { types } from "@vilocnv/allsetra-core";

export const getObjectsLocations = async (
  payload: ObjectsLocationsRequestDto
) => {
  try {
    const { accountId, filters } = payload;

    const response = await axiosInstance.post<types.IObject[]>(
      `/accounts/${accountId}/objects/locations`,
      filters
    );

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};
